module.exports = {

    /**
     * The width of the cover image
     *
     * @type {number}
     */
    backgroundWidth: 3840,

    /**
     * The height of the background image
     *
     * @type {number}
     */
    backgroundHeight: 2400,

    /**
     * The aspect ratio of the background image
     *
     * @type {number}
     * @public
     */
    backgroundRatio: (384 / 240)

};
